import {createMuiTheme, MuiThemeProvider} from '@material-ui/core';
import {SnackbarProvider} from 'notistack';
import React from 'react';
import {Provider} from 'react-redux';

import Routes from './routes';
import SplashScreen from './shared/components/splashscreen';
import ToastBootstrap from './shared/components/toastMessage';
import store from './store';

const theme = createMuiTheme({
  typography: {
    fontFamily: 'Ubuntu',
  },
});

const App: React.FC = () => {
  // tslint:disable-next-line:no-console
  console.log('ENV', {
    REACT_APP_HOST_LOCAL: process.env.REACT_APP_HOST_LOCAL,
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
    REACT_APP_DEBUG: process.env.REACT_APP_DEBUG,
    REACT_APP_VERSION: process.env.REACT_APP_VERSION,
  });

  return (
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3}>
          <SplashScreen />
          <ToastBootstrap />
          <Routes />
        </SnackbarProvider>
      </MuiThemeProvider>
    </Provider>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx